import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../layouts/Navbar";
import Sidebar from "../layouts/Sidebar";
import "./AddEmploye.css";
import { useNavigate } from "react-router-dom";
import Preloader from "../components/Preloader";
import { BsX } from "react-icons/bs";
import {
  FaBiking,
  FaEdit,
  FaMoneyBillWave,
  FaTrash,
  FaUser,
} from "react-icons/fa";
const AddEmployeeForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phonenumber: "",
    address: "",
    bloodGroup: "",
    fatherName: "",
    fatherCellNo: "",
    motherName: "",
    motherCellNo: "",
    photo: null,
    Salary_amount: "",
    Salary_data: "",
    role: "",
    designation: "",
    gender: "",
  });

  const [viewData, setViewData] = useState([]);
  const [message, setMessage] = useState("");
  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;
  const role = localStorage.getItem("role");
  const navi = useNavigate();
  const [viewEditData, setViewEditData] = useState({});
  const [loading, setLoading] = useState(false);

  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [fullphoto, setfullphoto] = useState(null);
  const [payPopup, setPayPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "photo") {
      setFormData({ ...formData, photo: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  // handleEditChange
  const handleEditChange = (e) => {
    const { name, value, type, files } = e.target;

    let newValue = value;

    // Restrict phone fields to numbers only
    if (
      name === "phonenumber" ||
      name === "fathercellnumber" ||
      name === "mothercellnumber"
    ) {
      newValue = value.replace(/\D/g, "");
    }

    setViewEditData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : newValue,
    }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      const response = await axios.post(`${api}/Admin/addemployee`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          apikey: apikey,
        },
      });
      setMessage(response.data.message);
      setFormData({
        name: "",
        phonenumber: "",
        address: "",
        bloodGroup: "",
        fatherName: "",
        fatherCellNo: "",
        motherName: "",
        motherCellNo: "",
        photo: null,
        Salary_amount: "",
        Salary_data: "",
        role: "",
      });
      getUserDetails(); // refresh list after adding
    } catch (error) {
      setMessage(error.response?.data?.message || "Error adding employee");
    } finally {
      setLoading(false);
    }
  };

const getUserDetails = async () => {
  try {
    const response = await axios.get(`${api}/Admin/viewemployee`, {
      headers: {
        apikey: apikey,
      },
    });

    const users = response.data.data || [];

    // Filter out users whose role is "admin"
    const filteredUsers = users.filter(user => user.role !== "admin");

    setViewData(filteredUsers);
  } catch (error) {
    console.log(error);
  }
};

  const handleViewEdit = async (id) => {
    setEdit(true);
    try {
      const view = await axios.get(`${api}/Admin/viewEditbyid/${id}`, {
        headers: {
          apikey: apikey,
        },
      });
      setViewEditData(view.data.data[0]);
      // console.log(view.data.data[0]);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async (id) => {
    // Ask for confirmation
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this employee?"
    );

    if (!confirmDelete) {
      return; // user canceled
    }

    try {
      const response = await axios.delete(`${api}/Admin/deleteEmployee/${id}`, {
        headers: { apikey: apikey },
      });
      alert(response.data.message || "Employee deleted successfully");
      getUserDetails(); // refresh the list
    } catch (error) {
      console.error("Error deleting employee:", error);
      alert(error.response?.data?.message || "Failed to delete employee");
    }
  };

  useEffect(() => {
    getUserDetails();

    if (role !== "admin") {
      navi("/");
    }
  }, []);

  // if (role !== "admin") {
  //   navi("/");
  // }

  const handleEdit = async (e, id) => {
    e.preventDefault(); // ✅ stop page refresh

    try {
      const data = new FormData();

      // ✅ Append all editable fields
      for (const key in viewEditData) {
        // Skip undefined or null values
        if (viewEditData[key] !== undefined && viewEditData[key] !== null) {
          data.append(key, viewEditData[key]);
        }
      }

      // ✅ Log to debug
      // console.log("🔄 Submitting edited data:", Object.fromEntries(data));

      const response = await axios.post(
        `${api}/Admin/Editemployeebyid/${id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            apikey: apikey,
          },
        }
      );

      // console.log("✅ Update success:", response.data);
      setMessage(response.data.message || "Employee updated successfully!");

      // ✅ Close modal and refresh list
      setEdit(false);
      getUserDetails();
    } catch (error) {
      console.error("❌ Update error:", error);
      setMessage(error.response?.data?.message || "Failed to update employee");
    }
  };

  if (loading) {
    return <Preloader />;
  }

  // ---------- MODAL OPEN ----------
  const openPayModal = () => {
    setPayPopup(true);
    setVisible(true);

    setTimeout(() => {
      setAnimate(true);
    }, 10);
  };
  // ---------- MODAL CLOSE ----------
  const closePayModal = () => {
    setAnimate(false);

    setTimeout(() => {
      setVisible(false);
      setPayPopup(false);
      setfullphoto(null); // remove image
    }, 300); // match CSS animation
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginTop: "30px",
              }}
            >
              <button
                onClick={() => setAdd((prev) => !prev)}
                style={{
                  backgroundColor: add ? "#dc3545" : "#0d6efd",
                  color: "#fff",
                  border: "none",
                  padding: "10px 18px",
                  fontSize: "16px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  margin: "10px",
                }}
                onMouseEnter={(e) => (e.target.style.opacity = "0.85")}
                onMouseLeave={(e) => (e.target.style.opacity = "1")}
              >
                {add ? "Close Form" : "Add +"}
              </button>
            </div>

            <div className="table-responsive">
              <table
                className="table table-striped"
                style={{ backgroundColor: "white" }}
              >
                <thead>
                  <tr>
                    <th>S No</th>
                    <th>Name</th>
                    <th>Phone Number</th>
                    <th>Blood Group</th>
                    <th>Photo</th>
                    <th>Employee Code</th>
                    <th>User ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {viewData.length > 0 ? (
                    viewData.map((item, index) => (
                      <tr key={item.userid}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.phonenumber}</td>
                        <td>{item.bloodgroup}</td>
                        <td>
                          <img
                            onClick={() => {
                              setfullphoto(`${api}/uploads/${item.photo}`);
                              openPayModal(); // <<< open popup here
                            }}
                            src={
                              item.photo
                                ? `${api}/uploads/${item.photo}`
                                : "/default-avatar.png"
                            }
                            alt={item.name}
                            width="50"
                            height="50"
                            style={{
                              objectFit: "cover",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          />
                        </td>
                        <td>{item.employee_code}</td>
                        <td>{item.userid}</td>
                        <td>
                          <button
                            className="btn btn-primary  btn-sm me-2"
                            onClick={() =>
                              navi("/admin/profileview", { state: item.userid })
                            }
                            title="Profile"
                          >
                            <FaUser />
                          </button>

                          <button
                            className="btn btn-success btn-sm me-2"
                            onClick={() => handleViewEdit(item.id)}
                            title="Edit"
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(item.userid)}
                            title="Delete"
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-muted py-3">
                        No employee data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {add && (
            <div className="popup-overlay">
              <div className="popup-content">
                <button
                  className="popup-close"
                  onClick={() => {
                    setAdd(false);
                    setMessage("");
                  }}
                >
                  ✖
                </button>
                <h4 className="card-title mb-4">Add Employee</h4>

                <form
                  className="form-sample"
                  onSubmit={handleSubmit}
                  encType="multipart/form-data"
                >
                  <p className="card-description">Personal Info</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Full Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Employee Name"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Phone</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="phonenumber"
                            value={formData.phonenumber}
                            maxLength={10}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                phonenumber: e.target.value.replace(/\D/g, ""),
                              }))
                            }
                            placeholder="10-digit number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Address
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Address"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Blood Group
                        </label>
                        <div className="col-sm-9">
                          <select
                            className="form-control"
                            name="bloodGroup"
                            value={formData.bloodGroup}
                            onChange={handleChange}
                            required
                            style={{ padding: "0.875rem 1.375rem" }}
                          >
                            <option value="">Select Blood Group</option>
                            <option value="A+">A+</option>
                            <option value="A−">A−</option>
                            <option value="B+">B+</option>
                            <option value="B−">B−</option>
                            <option value="AB+">AB+</option>
                            <option value="AB−">AB−</option>
                            <option value="O+">O+</option>
                            <option value="O−">O−</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Gender
                        </label>
                        <div className="col-sm-9">
                          <select
                            className="form-control"
                            style={{ padding: "0.875rem 1.375rem" }}
                            value={formData.gender}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                gender: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Role</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Role</label>
                        <div className="col-sm-9">
                          <select
                            className="form-control"
                            style={{ padding: "0.875rem 1.375rem" }}
                            value={formData.role}
                            onChange={(e) =>
                              setFormData({ ...formData, role: e.target.value })
                            }
                          >
                            <option value="">Select Role</option>
                            <option value="employee">Employee</option>
                            <option value="intership">Intership</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Designation
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="designation"
                            value={formData.designation}
                            onChange={handleChange}
                            placeholder="Designation"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="card-description">Parent Information</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Father's Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="fatherName"
                            value={formData.fatherName}
                            onChange={handleChange}
                            placeholder="Father's Name"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Father Cell
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="fatherCellNo"
                            value={formData.fatherCellNo}
                            maxLength={10}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                fatherCellNo: e.target.value.replace(/\D/g, ""),
                              }))
                            }
                            placeholder="10-digit number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Mother's Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="motherName"
                            value={formData.motherName}
                            onChange={handleChange}
                            placeholder="Mother's Name"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Mother Cell
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="motherCellNo"
                            value={formData.motherCellNo}
                            maxLength={10}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                motherCellNo: e.target.value.replace(/\D/g, ""),
                              }))
                            }
                            placeholder="10-digit number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="card-description">Upload Photo</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Photo</label>
                        <div className="col-sm-9">
                          <input
                            type="file"
                            className="form-control"
                            name="photo"
                            accept="image/*"
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="card-description">Salary Information</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Salary Amount
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="Salary_amount"
                            value={formData.Salary_amount}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                Salary_amount: e.target.value.replace(
                                  /\D/g,
                                  ""
                                ), // ✅ numbers only
                              }))
                            }
                            placeholder="Enter salary amount"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Salary Date
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="date"
                            className="form-control"
                            name="Salary_data"
                            value={formData.Salary_data}
                            onChange={handleChange} // ✅ simpler, since it's a date
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {message && (
                    <p
                      className="add-employee-message"
                      style={{
                        color: message === "Employee added" ? "green" : "red",
                      }}
                    >
                      {message}
                    </p>
                  )}

                  <button type="submit" className="btn btn-primary mt-3">
                    Add Employee
                  </button>
                </form>
              </div>
            </div>
          )}

          {edit && (
            <div className="popup-overlay">
              <div className="popup-content">
                <button
                  className="popup-close"
                  onClick={() => {
                    setEdit(false);
                    setMessage("");
                  }}
                >
                  ✖
                </button>
                <h4 className="card-title mb-4">Add Employee</h4>

                <form
                  className="form-sample"
                  onSubmit={(e) => handleEdit(e, viewEditData.id)}
                  encType="multipart/form-data"
                >
                  <p className="card-description">Personal Info</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Full Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={viewEditData.name}
                            onChange={handleEditChange}
                            placeholder="Employee Name"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Phone</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="phonenumber"
                            value={viewEditData.phonenumber}
                            maxLength={10}
                            onChange={handleEditChange}
                            placeholder="10-digit number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Address
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="address"
                            value={viewEditData.address}
                            onChange={handleEditChange}
                            placeholder="Address"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Blood Group
                        </label>
                        <div className="col-sm-9">
                          {/* <input
                            type="text"
                            className="form-control"
                            name="bloodgroup" // ✅ match state key
                            value={viewEditData.bloodgroup}
                            onChange={handleEditChange}
                            placeholder="e.g. O+"
                            required
                          /> */}
                          <select
                            className="form-control"
                            name="bloodgroup"
                            value={viewEditData.bloodgroup}
                            onChange={handleEditChange}
                            required
                            style={{ padding: "0.875rem 1.375rem" }}
                          >
                            <option value="">Select Blood Group</option>
                            <option value="A+">A+</option>
                            <option value="A−">A−</option>
                            <option value="B+">B+</option>
                            <option value="B−">B−</option>
                            <option value="AB+">AB+</option>
                            <option value="AB−">AB−</option>
                            <option value="O+">O+</option>
                            <option value="O−">O−</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Gender
                        </label>
                        <div className="col-sm-9">
                          <select
                            className="form-control"
                            style={{ padding: "0.875rem 1.375rem" }}
                            name="gender"
                            value={viewEditData.gender}
                            onChange={handleEditChange}
                          >
                            <option value="">Select Role</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Role</label>
                        <div className="col-sm-9">
                          <select
                            className="form-control"
                            name="role" // ✅ added name
                            value={viewEditData.role}
                            onChange={handleEditChange}
                            style={{ padding: "0.875rem 1.375rem" }}
                          >
                            <option value="">Select Role</option>
                            <option value="employee">Employee</option>
                            <option value="intership">Intership</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Designation
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="designation"
                            value={viewEditData.designation}
                            onChange={handleEditChange}
                            placeholder="Designation"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="card-description">Parent Information</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Father's Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="fathername" // ✅ match state key
                            value={viewEditData.fathername}
                            onChange={handleEditChange}
                            placeholder="Father's Name"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Father Cell
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="fathercellnumber" // ✅ match state key
                            value={viewEditData.fathercellnumber}
                            maxLength={10}
                            onChange={handleEditChange}
                            placeholder="10-digit number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Mother's Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="mothername" // ✅ match state key
                            value={viewEditData.mothername}
                            onChange={handleEditChange}
                            placeholder="Mother's Name"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Mother Cell
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="mothercellnumber" // ✅ match state key
                            value={viewEditData.mothercellnumber}
                            maxLength={10}
                            onChange={handleEditChange}
                            placeholder="10-digit number"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="card-description">Upload Photo</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Photo</label>
                        <div className="col-sm-9">
                          <input
                            type="file"
                            className="form-control"
                            name="photo"
                            accept="image/*"
                            onChange={handleEditChange}
                            // required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <p className="card-description">Salary Information</p>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Salary Amount
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            name="Salary_amount" // ✅ use consistent lowercase or camelCase
                            value={viewEditData.Salary_amount}
                            onChange={handleEditChange}
                            placeholder="Enter salary amount"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Salary Date
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="date"
                            className="form-control"
                            name="Salary_data"
                            value={viewEditData.Salary_data}
                            onChange={handleEditChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {message && (
                    <p
                      className="add-employee-message"
                      style={{
                        color:
                          message === "Employee updated successfully"
                            ? "green"
                            : "red",
                      }}
                    >
                      {message}
                    </p>
                  )}

                  <button type="submit" className="btn btn-primary mt-3">
                    Edit Employee
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>

      {visible && fullphoto && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: animate ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            transition: "background 0.5s ease",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              width: "400px",
              maxWidth: "90%",
              transform: animate ? "translateY(0)" : "translateY(200%)",
              transition: "transform 0.5s ease",
              boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
            }}
            className="hide-scrollbar"
          >
            {/* CLOSE BUTTON */}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <BsX
                style={{
                  cursor: "pointer",
                  fontSize: "25px",
                  border: "1px solid red",
                  color: "red",
                  borderRadius: "50%",
                }}
                onClick={closePayModal}
              />
            </div>

            {/* IMAGE PREVIEW */}
            <div className="form-group">
              <label>Employee Photo</label>
              <img
                src={fullphoto}
                alt="Employee"
                style={{
                  width: "100%",
                  height: "350px",
                  marginTop: "10px",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddEmployeeForm;
